import { getFormattedAmount } from '@zonofi/common';

export const LedgerRowClosing = ({
  closingBalance,
  isTrialBalanceLoading = false,
}: {
  closingBalance: number | string;
  isTrialBalanceLoading?: boolean;
}) => {
  const balanceValue = Number(closingBalance) || 0;
  const prefix = balanceValue >= 0 ? 'DR ' : 'CR ';
  const displayValue = Math.abs(balanceValue);

  return (
    <div className="ledger-grid-closing ledger-view-closing font-regular  font-primary-regular">
      <span className="ledger-view-closing-text font-semibold font-primary-semibold">
        Closing Balance
      </span>
      <span className="ledger-view-closing-amount font-semibold font-primary-semibold">
        {closingBalance
          ? `${prefix}${getFormattedAmount(displayValue, true)}`
          : '-'}
      </span>
    </div>
  );
};
